import { BlueprintEditorTool, BlueprintEditorTools } from '../../definitions'
import { CameraToolbar } from './components/CameraToolbar'
import useMainCanvas from './hooks/useMainCanvas'

const CameraManager: BlueprintEditorTool = {
  key: BlueprintEditorTools.Focus,
  authCheck: () => true,
  components: {
    editor: [CameraToolbar],
  },
  hooks: {
    useMainCanvas,
  },
}

export default CameraManager
